import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OpenBreezeAssistantConfirmModal = ({
  onConfirm,
  onCancel
}) => /*#__PURE__*/_jsxs(Modal, {
  onEsc: onCancel,
  width: 533,
  display: "flex",
  alignItems: "center",
  children: [/*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.breezeSwitch.title"
      })
    }), /*#__PURE__*/_jsx(DialogCloseButton, {
      "aria-label": I18n.text('academy-ai-assistant.breezeSwitch.close'),
      onClick: onCancel
    })]
  }), /*#__PURE__*/_jsx(DialogBody, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-ai-assistant.breezeSwitch.body"
    })
  }), /*#__PURE__*/_jsxs(DialogFooter, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: "primary",
      onClick: onConfirm,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.breezeSwitch.confirm"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "tertiary-light",
      onClick: onCancel,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.breezeSwitch.cancel"
      })
    })]
  })]
});